export const REFRESH_URL = `${process.env.REACT_APP_API_AUTH_URL}/api/auth/refresh`;
export const SERVER_TIME_URL = `${process.env.REACT_APP_API_AUTH_URL}/api/server-time`;
export const PLATFORM = `${process.env.REACT_APP_PLATFORM}`;
/* 
export default async function ExpireAxios(refreshToken: string) {
  const {data} = await axios.get(SERVER_TIME_URL);
  var expireTime = moment.unix(auth.expireTime);
  var duration = getDate.diff(expireTime);
  return await axios.post(REFRESH_URL, { refreshToken, platform: PLATFORM });
} */
